export default {"src":"/_next/static/media/image 6.faba2d90.svg","height":45,"width":77,"blurWidth":0,"blurHeight":0};